var data = {
	"body": "<path d=\"M23.184 2.654l-10.967 3.5V2.696L.39 6.47v10.025l10.2-3.258v3.441L24 12.403l-3.634-3.55zM10.592 4.929v6.592l-8.567 2.733V7.662zm9.683.367l-1.85 3.9l2.542 2.467l-8.75 2.791V7.871zM1.741 17.863c-.958 0-1.741.783-1.741 1.741c0 .959.783 1.742 1.741 1.742a1.74 1.74 0 1 0 0-3.483z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
export default data;
